import styled, { css } from "styled-components";
import TextareaAutosize from "react-textarea-autosize";

export const TextInput = styled.input`
  padding: 4px 10px;
  border-radius: 4px;
  margin-bottom: 15px;
  width: 100%;
  line-height: 28px;
  transition: all 0.2s;

  ${(props) =>
    props.invalid
      ? css`
          border: 1px solid red;
          &:focus {
            border: 1px solid red;
          }
        `
      : css`
          border: 1px solid hsl(0, 0%, 70%);
          &:focus {
            border: 1px solid #2684ff;
          }
        `}
`;

export const Header = styled.div`
  font-weight: 600;
  font-size: 20px;
  margin-bottom: 20px;
`;

export const InputLabel = styled.div`
  font-size: 16px;
  margin-bottom: 10px;
`;

export const ModalContentWrapper = styled.div`
  padding: 30px 30px 20px;
`;

export const CreateButtonWrapper = styled.div`
  margin-top: 20px;
  margin-bottom: 20px;
  float: right;
`;

export const AddressInput = styled(TextareaAutosize)`
  padding: 10px;
  width: 100%;
  border: 1px solid hsl(0, 0%, 70%);
  border-radius: 5px;
  margin-bottom: 15px;
  &:focus {
    box-shadow: 0 0 10px rgb(3 169 244 / 20%);
    border: 1px solid #1e22ff;
  }
`;
